import { useEffect, useState } from "react"
import { currentGuestToken, ensureGuestToken, GUEST_SESSION_EVENT } from "@/lib/guest-session"

/** Reports current guest access after restoring the same server-issued guest when necessary. */
export function useAuthStatus() {
  const [authenticated, setAuthenticated] = useState(() => !!currentGuestToken())
  useEffect(() => {
    let mounted = true
    const update = () => { if (mounted) setAuthenticated(!!currentGuestToken()) }
    void ensureGuestToken().then(update)
    window.addEventListener(GUEST_SESSION_EVENT, update)
    window.addEventListener("storage", update)
    return () => {
      mounted = false
      window.removeEventListener(GUEST_SESSION_EVENT, update)
      window.removeEventListener("storage", update)
    }
  }, [])
  return authenticated
}
